import React from "react";
import { createRoot } from "react-dom/client";

import SignUpMain from "./containers/SignupMain";
import createRouter from './router/router';

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container)


root.render(<SignUpMain router={createRouter()}/>);